import angular from "angular";

import AdminBicyclesModuleRouting from "./admin-bicycles.module.routing";

export default angular
  .module("vt-admin-bicycles", [])
  .config(AdminBicyclesModuleRouting);
